import adminActions from './admin';

export default {
  ...adminActions
};
